import React from "react";

import * as S from "./ParagraphTitle.style";

interface Props {
  title: React.ReactNode;
  type?: "default" | "section";
}

const ParagraphTitle = ({ title, type = "default" }: Props) => {
  if (type === "section") {
    return (
      <S.ParagraphSectionTitleWrapper>{title}</S.ParagraphSectionTitleWrapper>
    );
  }
  return <S.ParagraphTitleWrapper>{title}</S.ParagraphTitleWrapper>;
};

export default ParagraphTitle;
